// Posts are JSON files in src/content/posts, managed at /admin (or edited by hand).
// Each file: { title, date: "YYYY-MM-DD", tag, excerpt, author?, image?, body (markdown) }
let entries;
if (process.env.NODE_ENV === "test") {
  // Jest has no require.context, so read the folder directly.
  const fs = require("fs");
  const path = require("path");
  const dir = path.join(__dirname, "../content/posts");
  entries = fs
    .readdirSync(dir)
    .filter((f) => f.endsWith(".json"))
    .map((f) => [f, JSON.parse(fs.readFileSync(path.join(dir, f), "utf8"))]);
} else {
  const ctx = require.context("../content/posts", false, /\.json$/);
  entries = ctx.keys().map((k) => [k.replace(/^\.\//, ""), ctx(k)]);
}

// require.context can list a file under more than one key, so dedupe by slug.
const bySlug = new Map();
entries.forEach(([file, data]) => {
  const slug = file.replace(/^.*\//, "").replace(/\.json$/, "");
  bySlug.set(slug, { slug, ...data });
});

export const posts = [...bySlug.values()]
  .filter((p) => p.title && p.date)
  .sort((a, b) => String(b.date).localeCompare(String(a.date)));
